export const environment = {
    production: false,
    apiUrl: 'https://noprod.api.infinity.farfisa.com/v1',
    apiCallUrl: 'https://lnabbwisnc.execute-api.eu-central-1.amazonaws.com/noprod/api/v1',
    userPoolId: "eu-central-1_IyHnuabEa",
    userPoolClientId: "7g0iapg274jn5lmo9ftp1m00om",
    identityPoolId: "eu-central-1:b0e6420a-1956-4090-8ee9-b946bf8bf37a",
    alexaRedirectUrl: "https://noprod-infinity-farfisa.auth.eu-central-1.amazoncognito.com/oauth2/authorize",
    mapAPIKey: import.meta.env.NG_APP_PUBLIC_MAP_API_KEY,
    firebaseConfig: {
        apiKey: "AIzaSyAYvosGBDsj3al0ZX6VGhb4m3TsT6Rnlqo",
        authDomain: "infinity-noprod.firebaseapp.com",
        projectId: "infinity-noprod",
        storageBucket: "infinity-noprod.firebasestorage.app",
        messagingSenderId: "537864638591",
        appId: "1:537864638591:web:a710a823d476dcd444ef4a",
        measurementId: "G-YMT0FPWVKZ"
    },
    vapidKey: "BFGpvPZfgdI2eo6a91QhasIQzAkaqw8k25w2B1fyGq1dz3vi65uw-IDkrm-Zp-pVe-Ygsg5J1OQ3u1BdI5DbiCc",
    serviceWorkerFile: "/firebase-messaging-sw-noprod.js",
    mqttTopicPrefix: "infinity-noprod",
    customAuthorizer: "noprod-infinity-IoTCustomAuthorizer",
    customAuthorizerPublicKey: `
-----BEGIN PRIVATE KEY-----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-----END PRIVATE KEY-----
`
};
